const isAu = () => {
    return window.Shopify.country === `AU`
}

const isCa = () => {
    return window.Shopify.country === `CA`
}

const isNZ = () => {
    return window.Shopify.country === `NZ`
}

export {isAu, isCa, isNZ}